import { useEffect, useState } from "react";
import { Form, Modal, Typography } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";

import { addTasks } from "@/api/sprints";
import { getTasksList } from "@/api/sprints";

const { Text } = Typography;

// Окно для добавления существующих задач в спринт, содержит форму
const SprintTasksModal = ({
  sprint = {},
  visible,
  onSave,
  onCancel,
  isAdmins,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [tasksOptions, setTasksOptions] = useState([]);
  const [isTasksLoading, setIsTasksLoading] = useState(false);

  const newTasksList = Form.useWatch("tasks_uuids", form);

  // При инициализации компонента запрашиваем список задач
  useEffect(() => {
    fetchTaskList();

    // eslint-disable-next-line
  }, [sprint]);

  const fetchTaskList = async () => {
    setIsTasksLoading(true);
    try {
      const { tasks } = await getTasksList({ uuid: sprint?.uuid }, isAdmins);

      const mappedTasks = tasks.map((item) => ({
        ...item,
        label: `№${item.task_number} - ${item.name}`,
        value: item.uuid,
      }));

      // Сортируем задачи по убыванию номеров, а так же исключаем те, что уже выбраны
      setTasksOptions(
        mappedTasks
          .sort((a, b) => b.task_number - a.task_number)
          .filter((item) => !item.inSprint)
      );
    } catch (error) {
      console.log(error);
      setTasksOptions([]);
    } finally {
      setIsTasksLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      await addTasks({
        uuid: sprint?.uuid,
        taskUuids: values.tasks_uuids || [],
      });

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title="Добавить существующие задачи"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Добавить"
      cancelText="Отмена"
      okButtonProps={{
        loading: isLoading,
        disabled: !newTasksList?.length,
      }}
    >
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item name="tasks_uuids" label="Задачи">
          <CustomSelect
            placeholder={
              isTasksLoading ? "Загрузка задач..." : "Начните вводить"
            }
            options={tasksOptions}
            mode="multiple"
            showSearch
            allowClear
            optionFilterProp="label"
            loading={isTasksLoading}
            disabled={isTasksLoading}
          />
        </Form.Item>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default SprintTasksModal;
